import React, { useState } from 'react';
import { gallery } from '../mock';
import { X } from 'lucide-react';

const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" className="relative bg-[#0f0d0a] py-28 md:py-36 border-y border-[#c9a961]/10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="reveal max-w-2xl mb-14">
          <div className="flex items-center gap-3 mb-5">
            <div className="h-px w-10 bg-[#c9a961]" />
            <span className="text-[#c9a961] tracking-[0.35em] text-xs uppercase">Galerie</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#f5efe4] leading-tight">
            Nos dernières <em className="text-[#c9a961]">réalisations</em>.
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {gallery.map((src, i) => (
            <button
              key={i}
              onClick={() => setActive(src)}
              className={`reveal relative overflow-hidden group ${
                i % 5 === 0 ? 'col-span-2 row-span-2 aspect-square' : 'aspect-square'
              }`}
            >
              <img
                src={src}
                alt={`Réalisation ${i + 1}`}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[900ms] ease-out"
              />
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/10 transition-colors" />
              <div className="absolute inset-0 border border-[#c9a961]/0 group-hover:border-[#c9a961]/60 transition-colors" />
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {active && (
        <div
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[70] bg-black/90 backdrop-blur-sm flex items-center justify-center p-6 cursor-zoom-out"
        >
          <button
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 text-[#f5efe4] hover:text-[#c9a961] transition-colors"
            aria-label="Fermer"
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={active}
            alt="Aperçu"
            className="max-h-[85vh] max-w-[92vw] object-contain"
          />
        </div>
      )}
    </section>
  );
};

export default Gallery;
